<template>
    <a class="back-to-top" @click="scrollToTop">
<!--        <i class="fas fa-arrow-up" />-->
        <font-awesome-icon icon="fa-solid fa-arrow-up" />
        Back to top
    </a>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
library.add(faArrowUp);

export default {
    components: {
        FontAwesomeIcon,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        scrollToTop() {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
    }
}
</script>

<style lang="scss">
.back-to-top {
    position: fixed;
    bottom: 0;
    right: 0;
    background-color: #ddd;
    padding: 5px 10px;
    border-radius: 10px;
    cursor: pointer;
}
</style>
